import { KeyValueStorage } from './KeyValueStorage';

export interface SessionStorage {
  getSessionId(): string;
}

const SESSION_ID_KEY = 'currentSessionId';

export function createSessionIdStorage(
  storage: KeyValueStorage,
): SessionStorage {
  function getSessionId(): string {
    let currentSessionId = storage.getItem(SESSION_ID_KEY);

    if (currentSessionId === undefined) {
      currentSessionId = crypto.randomUUID();
      storage.setItem(SESSION_ID_KEY, currentSessionId);
    }

    return currentSessionId;
  }

  return {
    getSessionId,
  };
}
